export default __webpack_public_path__ + "static/media/defence.dcd444a0.jpg";